import { render, staticRenderFns } from "./professionalInstitutions.vue?vue&type=template&id=e341fb10&scoped=true&"
import script from "./professionalInstitutions.vue?vue&type=script&lang=js&"
export * from "./professionalInstitutions.vue?vue&type=script&lang=js&"
import style0 from "./professionalInstitutions.vue?vue&type=style&index=0&id=e341fb10&prod&lang=scss&scoped=true&"
import style1 from "./professionalInstitutions.vue?vue&type=style&index=1&id=e341fb10&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e341fb10",
  null
  
)

export default component.exports